const axios = require('axios')
const { URL } = require('./constant')

class Product {
  async searchProduct (product, config) {
    const response = await axios.post(`${URL}/product/search/list/${config.page}/${product}`, {
      lat: config.location.lat,
      ln: config.location.ln
    })

    return response.data
  }

  async detailProduct (product) {
    const response = await axios.get(`${URL}/product/detail/${product}`)
    return response.data
  }

  async activeProducts (page = 1, axiosPptions) {
    const response = await axios.get(`${URL}/product/list/true/${page}`, axiosPptions)
    return response.data
  }

  async listToCategory (category, page) {
    const response = await axios.get(`${URL}/product/category/${category}/${page}`)
    return response.data
  }

  async listToBranch (token, id, page) {
    const response = await axios.get(`${URL}/product/allbranch/${id}/${page}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    )
    return response.data
  }
}

export default new Product()
